/* One responsive image: update its text alternatives when the picture source changes. */
(() => {
  if (customElements.get('zfw26-responsive-image')) return;
  customElements.define('zfw26-responsive-image', class extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('img');
      if (!this.image) return;
      this.media = window.matchMedia('(max-width: 749px)');
      this.updateImageText = () => {
        const prefix = this.media.matches ? 'mobile' : 'desktop';
        this.image.alt = this.getAttribute('data-' + prefix + '-alt') || '';
        const name = this.getAttribute('data-' + prefix + '-name');
        if (name) this.image.setAttribute('title', name);
        else this.image.removeAttribute('title');
      };
      this.media.addEventListener('change', this.updateImageText);
      this.updateImageText();
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.updateImageText);
    }
  });
})();